// extracted by mini-css-extract-plugin
module.exports = {"tabs":"test-page_tabs__189Bn","content":"test-page_content__2B-W4"};